import React from 'react';

export default function AuthPanel({ children }) {
    return (
        <div className="relative w-full max-w-[400px] mx-auto">
            {/* Decorative yellow logo */}
            <div className="absolute -top-[210px] -right-[340px] w-[400px] h-[394px] bg-contain bg-no-repeat hidden lg:block pointer-events-none" style={{ backgroundImage: 'url(/assets/img/layout/logo.svg)' }} />

            <div className="relative rounded-[3px] border border-[#bbb] bg-white">
                <div className="p-[30px]">
                    <div className="flex justify-center mb-6">
                        <img src="/assets/img/layout/schotpoort-logo-alt.svg" alt="Schotpoort Connect" className="w-[300px] h-[43px]" />
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
}
